module.exports = __webpack_public_path__ + "static/media/policy.5f713665.svg";